export class CalcRunCtrl {
    public id: number;
    public runCtrlId: number;
    public comm_plan_id: any;
    public cal_run_id: any;
    public cal_run_id_str: string;
    public run_control_name: string;
    public description: string;
    public locked: string;
    public sc_emp_id: any;
    public created_by: string;
    public updated_by: string;
    public created_dt: Date;
    public updated_dt: Date;
    public saleschannel: any;
    public commPlan: string;
    public empName: string;
    public run_all_open_flg: string;
    public active_status: string;
    public empIdList: any;

    public calendar_type: string;
    public valid_from_dt: Date;
    public valid_to_dt: Date;
    constructor() {
        this.calendar_type = null;
        this.valid_from_dt = null;
        this.valid_to_dt = null;

        this.active_status = null;
        this.id = null;
        this.comm_plan_id = null;
        this.cal_run_id = null;
        this.cal_run_id_str = null;
        this.run_control_name = null;
        this.description = null;
        this.locked = null;
        this.sc_emp_id = null;
        this.created_by = null;
        this.created_dt = null;
        this.updated_by = null;
        this.updated_dt = null;
        this.saleschannel = null;
        this.empName = null;
        this.commPlan = null;
        this.empIdList = [];
        this.runCtrlId = 0;
        this.run_all_open_flg = 'N';
    }
}
